import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";
import changeOrPushModel from "@/mixin/store/api/changeOrPushModel";
import pushModel from "@/mixin/store/api/pushModel";
import deleteModel from "@/mixin/store/api/deleteModel";

export default {
    actions: {
        fetchCompanyCounts(context, search) {
            return fetchModels(context, 'company_counts', search.page, 'updateCompanyCounts');
        },
        fetchCompanyCountsAll(context) {
            return fetchModels(context, 'company_counts', null, 'updateCompanyCounts');
        },
        fetchCompanyCountsTotalAmount(context) {
            return fetchModel(context, 'company_counts/total_amount', null, 'updateCompanyCountsTotalAmount');
        },
        fetchCompanyCount(context, id) {
            return fetchModel(context, 'company_counts', id, 'updateCompanyCount');
        },
        putCompanyCount(context, data) {
            return changeOrPushModel(context, 'company_counts', data, 'updateCompanyCount')
        },
        pushCompanyCount(context, data) {
            return pushModel(context, 'company_counts', data, )
        },
        deleteCompanyCount(context, id) {
            return deleteModel(context, 'company_counts', id);
        },
    },
    mutations: {
        updateCompanyCounts(state, data) {
            state.companyCounts = data
        },
        updateCompanyCountsTotalAmount(state, data) {
            state.companyCountsTotalAmount = data
        },
        updateCompanyCount(state, data) {
            state.companyCount = data
        },
    },
    state: {
        companyCounts: {
            models: [],
            totalItems: 0,
        },
        companyCountsTotalAmount: {},
        companyCount: {
            id: null,
            isIncome: true,
            reason: null,
            sum: null,
            sumCurrency: {},
            createAt: null
        }
    },
    getters: {
        getCompanyCounts(state) {
            return state.companyCounts.models
        },
        getCompanyCountsTotalCount(state) {
            return state.companyCounts.totalItems
        },
        getCompanyCount(state) {
            return state.companyCount
        },
        getCompanyCountTotalAmount(state) {
            return state.companyCountsTotalAmount
        },

    },
}